import euQuickstart from "./end-user/quickstart.md";
import euManual from "./end-user/manual.md";
import euFaq from "./end-user/faq.md";
import adminQuickstart from "./admin/quickstart.md";
import adminManual from "./admin/manual.md";
import adminFaq from "./admin/faq.md";

export const DOCS_NAV = [
  {
    id: "end-user",
    label: "End User",
    pages: [
      { id: "quickstart", label: "Quickstart", src: euQuickstart },
      { id: "manual", label: "Manual", src: euManual },
      { id: "faq", label: "FAQ", src: euFaq },
    ],
  },
  {
    id: "admin",
    label: "Administrator",
    pages: [
      { id: "quickstart", label: "Quickstart", src: adminQuickstart },
      { id: "manual", label: "Manual", src: adminManual },
      { id: "faq", label: "FAQ", src: adminFaq },
    ],
  },
];
